var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

(function () {
  var e = {
    703: function _(e, r, t) {
      "use strict";

      var o = t(414);

      function i() {}

      function s() {}

      s.resetWarningCache = i, e.exports = function () {
        function e(e, r, t, i, s, n) {
          if (n !== o) {
            var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw a.name = "Invariant Violation", a;
          }
        }

        function r() {
          return e;
        }

        e.isRequired = e;
        var t = {
          array: e,
          bool: e,
          func: e,
          number: e,
          object: e,
          string: e,
          symbol: e,
          any: e,
          arrayOf: r,
          element: e,
          elementType: e,
          instanceOf: r,
          node: e,
          objectOf: r,
          oneOf: r,
          oneOfType: r,
          shape: r,
          exact: r,
          checkPropTypes: s,
          resetWarningCache: i
        };
        return t.PropTypes = t, t;
      };
    },
    697: function _(e, r, t) {
      e.exports = t(703)();
    },
    414: function _(e) {
      "use strict";

      e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }
  },
      r = {};

  function t(o) {
    var i = r[o];
    if (void 0 !== i) return i.exports;
    var s = r[o] = {
      exports: {}
    };
    return e[o](s, s.exports, t), s.exports;
  }

  t.n = function (e) {
    var r = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(r, {
      a: r
    }), r;
  }, t.d = function (e, r) {
    for (var o in r) {
      t.o(r, o) && !t.o(e, o) && Object.defineProperty(e, o, {
        enumerable: !0,
        get: r[o]
      });
    }
  }, t.o = function (e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var o = {};
  (function () {
    "use strict";

    t.r(o), t.d(o, {
      default: function _default() {
        return a;
      }
    });

    var e = require("react");

    var r = t.n(e),
        i = t(697),
        s = t.n(i);

    var n = /*#__PURE__*/function (_r$Component) {
      _inherits(n, _r$Component);

      var _super = _createSuper(n);

      function n(e) {
        var _this;

        _classCallCheck(this, n);

        _this = _super.call(this), _this.state = {
          roundedColor: e.roundedColor,
          hoverColor: e.hoverColor,
          isHover: !1
        };
        return _this;
      }

      _createClass(n, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          var _this$props = this.props,
              e = _this$props.roundedColor,
              t = _this$props.imageWidth,
              o = _this$props.imageHeight,
              i = _this$props.roundedSize,
              s = _this$props.hoverColor,
              _n = _this$props.image,
              a = _this$props.borderRadius;
          return r().createElement("div", {
            onMouseEnter: function onMouseEnter() {
              return _this2.setState({
                isHover: !0
              });
            },
            onMouseLeave: function onMouseLeave() {
              return _this2.setState({
                isHover: !1
              });
            },
            style: {
              background: "".concat(this.state.isHover && "" != s ? s : e),
              width: "".concat(t, "px"),
              height: "".concat(o, "px"),
              borderRadius: "50%" === a ? "50%" : "".concat(a, "px"),
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transition: "all 0.5s ease"
            }
          }, r().createElement("img", {
            style: {
              width: t - i + "px",
              height: o - i + "px",
              borderRadius: "50%" === a ? "50%" : a - i / 2 + "px"
            },
            src: _n
          }));
        }
      }]);

      return n;
    }(r().Component);

    n.propTypes = {
      imageWidth: s().string.isRequired,
      imageHeight: s().string.isRequired,
      roundedSize: s().string.isRequired,
      roundedColor: s().string.isRequired,
      hoverColor: s().string.isRequired,
      image: s().string.isRequired,
      borderRadius: s().string.isRequired
    }, n.defaultProps = {
      imageWidth: "200",
      imageHeight: "200",
      roundedSize: "20",
      roundedColor: "#1B3D50",
      hoverColor: "",
      borderRadius: "50%"
    };
    var a = n;
  })(), module.exports = o;
})();